// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y0RC","col":"styles_col__10LxT"};